<template>
  <div class="container container_40 portfolio-details">
      <template v-if="token">
        <div class="portfolio-details__description">
          <p class="text_large text_bold">
            {{ i18n.lbl_description() }}
          </p>
          <p class="text_small text_margin">
            {{ sale.details.short_description }}
          </p>
        </div>
        <detail-row class="text_margin" :prop="i18n.com_name()">
          <company-name-getter :id="token.owner" />
        </detail-row>
        <detail-row class="text_margin" :prop="i18n.sale_investment_project_name()"
                    :value="sale.details.name"/>
        <detail-row class="text_margin" :prop="i18n.lbl_token_code()" :value="token.code"/>
        <detail-row class="text_margin" :prop="i18n.lbl_current_price()"
                    :value="`${ token.price } ${ token.convertedAsset }`"/>
        <detail-row class="text_margin" :prop="i18n.lbl_max_issuance()"
                    :value="`${ token.max } ${ token.code }`"/>
      </template>
  </div>
</template>

<script>
import { i18n } from '@js/i18n'

import CompanyNameGetter from '../common/CompanyNameGetter'
import DetailRow from '../common/Detail.Row'
export default {
  name: 'portfolio-details',
  components: {
    CompanyNameGetter,
    DetailRow
  },
  props: ['token'],
  data: _ => ({
    selected: null,
    i18n
  }),
  async created () {
  },
  computed: {
    sale () {
      return this.token.tokenSale
    }
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
  @import '~scss/variables.scss';
  @import '~scss/mixins.scss';

  .portfolio-details {
    margin-bottom: 24px;
    width: 100%;

    &__description {
      border-bottom: 1px solid $col-border;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/portfolio/Portfolio.Details.vue